import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OAuthOptions = ({ onOAuthSignup, loading = false }) => {
  const [oauthLoading, setOAuthLoading] = useState({
    google: false,
    github: false
  });

  const oauthProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      color: 'var(--color-error)',
      description: 'Continue with Google account'
    },
    {
      id: 'github',
      name: 'GitHub',
      icon: 'Github',
      color: 'var(--color-foreground)',
      description: 'Continue with GitHub account'
    }
  ];

  const handleOAuthClick = async (provider) => {
    setOAuthLoading(prev => ({ ...prev, [provider?.id]: true }));
    
    try {
      // Simulate OAuth flow
      await new Promise(resolve => setTimeout(resolve, 1500));
      onOAuthSignup(provider?.id);
    } catch (error) {
      console.error(`${provider?.name} OAuth error:`, error);
    } finally {
      setOAuthLoading(prev => ({ ...prev, [provider?.id]: false }));
    }
  };

  return (
    <div className="space-y-4">
      {/* Divider */}
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">Or continue with</span>
        </div>
      </div>
      {/* OAuth Buttons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {oauthProviders?.map((provider) => (
          <Button
            key={provider?.id}
            variant="outline"
            size="default"
            onClick={() => handleOAuthClick(provider)}
            loading={oauthLoading?.[provider?.id]}
            disabled={loading || oauthLoading?.[provider?.id]}
            className="justify-center"
          >
            <div className="flex items-center space-x-2">
              <Icon 
                name={provider?.icon} 
                size={18} 
                color={provider?.color}
              />
              <span className="font-medium">{provider?.name}</span>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default OAuthOptions;